var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import {} from "react";
export function BaseIcon(_a) {
    var { size = 24, alt = "", children } = _a, props = __rest(_a, ["size", "alt", "children"]);
    return (_jsx("svg", Object.assign({ role: "img", xmlns: "http://www.w3.org/2000/svg", "aria-label": alt, width: size, height: size }, props, { children: children })));
}
